import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getSuppliers = createAsyncThunk('alix/get-suppliers', async (payload, toolkit) => {
  return await AxiosClient(
    'GET',
    `/v1/risk-management/filter/supplier?clientId=${payload.clientId}`,
    {},
    toolkit,
  )
})

export const getSupplierStatisticsData = createAsyncThunk(
  'alix/get-supplier-statistics-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/supplier-scoreboard/supplier-statistics?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      payload,
      toolkit,
    )
  },
)

export const getSupplierTableData = createAsyncThunk(
  'alix/get-supplier-table-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/supplier-scoreboard/supplier-product-details?supplierId=${payload.supplierId}&page=${payload.page}&pageSize=${payload.pageSize}&clientId=${payload.clientId}`,
      payload,
      toolkit,
    )
  },
)

export const getSuppliersListTableData = createAsyncThunk(
  'alix/supplier-score-details',
  async (payload, toolkit) => {
    return await AxiosClient(
      'POST',
      '/v1/risk-management/supplier-scoreboard/supplier-score-details',
      payload,
      toolkit,
    )
  },
)
